/**
 * Backward-compatibility shim.
 *
 * All existing code using:
 *   const { showAlert } = useAlert();
 *   showAlert({ type: "success", message: "Saved!" });
 *
 * continues to work unchanged. Internally it delegates to the new
 * useToast() hook from ToastProvider (mounted in AppProviders).
 */
import { useCallback } from "react";
import { useToast } from "../components/ui/ModernToast";

export const useAlert = () => {
  const toast = useToast();

  const showAlert = useCallback(({ type = "info", message, title, duration }) => {
    const resolvedTitle = title || (type.charAt(0).toUpperCase() + type.slice(1));
    toast({ type, title: resolvedTitle, message, duration });
  }, [toast]);

  return { showAlert };
};

// No-op provider — ToastProvider in AppProviders handles rendering.
const AlertProvider = ({ children }) => children;
export default AlertProvider;
